<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate('')"
        >新增</el-button
      >
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.no"
        placeholder="请输入商品编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_merge"
        placeholder="是否是合成产品"
        clearable
        style="width: 170px"
        class="filter-item"
      >
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
      <el-select
        v-model="listQuery.is_energy_merge"
        placeholder="是否是能量合成产品"
        clearable
        style="width: 180px"
        class="filter-item"
      >
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
      <el-select
        v-model="listQuery.is_on"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>
      <el-select
        v-model="listQuery.is_review_show"
        placeholder="是否往期回顾"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
      <!-- <el-select
        v-model="listQuery.type"
        placeholder="商品类型"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="普通抢购商品" :value="1" />
        <el-option label="预约抢购商品" :value="2" />
      </el-select> -->
      <el-select
        v-model="listQuery.category"
        placeholder="商品类别"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="普通NFT" :value="1" />
        <el-option label="盲盒NFT" :value="2" />
        <!-- <el-option label="合成NFT" :value="3" /> -->
      </el-select>
      <el-select
        v-model="listQuery.product_category_id"
        placeholder="请选择专区"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option
          v-for="item in product_categories"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.art_museum_id"
        placeholder="请选择艺术馆"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option
          v-for="item in art_museums"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter">
        搜索
      </el-button>

      <!-- <el-upload
        class="filter-item"
        accept=".xlsx,.xls"
        action=""
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleImportOrders"
      >
        <el-button type="warning" icon="el-icon-upload"> 导入空投 </el-button>
      </el-upload> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @cell-click="cellClick"
    >
      <el-table-column label="权重" width="95" align="center">
        <template slot-scope="scope">
          <el-input
            ref="gain"
            size="mini"
            v-if="scope.row.isEdit"
            @blur="blurClick(scope)"
            :autofocus="true"
            v-model="scope.row.sort_weight"
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input>
          <span v-else
            >{{ scope.row.sort_weight }}<i class="el-icon-edit"></i
          ></span>
          <!-- {{ scope.$index + 1 }} -->
          <!-- {{ scope.row.sort_weight }} -->
        </template>
      </el-table-column>
      <el-table-column label="商品ID" width="95" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="商品专区" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.product_category">
            {{ scope.row.product_category.name }}</el-tag
          >
          <i v-else>-</i>
        </template>
      </el-table-column>
      <el-table-column label="艺术馆" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.art_museum">
            {{ scope.row.art_museum.name }}</el-tag
          >
          <i v-else>-</i>
        </template>
      </el-table-column>
      <el-table-column label="商品类别" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.category == 1" type="primary">普通NFT</el-tag>
          <el-tag v-else-if="scope.row.category == 2" type="success"
            >盲盒NFT</el-tag
          >
          <el-tag v-else type="warning">合成NFT</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否为合成商品" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_setting_merge_info || scope.row.merge_mode_num"
            type="success"
            >是</el-tag
          >
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="是否为能量合成商品"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="
              scope.row.is_setting_energy_merge_info ||
              scope.row.energy_merge_mode_num
            "
            type="success"
            >是</el-tag
          >
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1" type="primary"
            >普通抢购商品</el-tag
          >
          <el-tag v-else-if="scope.row.type == 2" type="success"
            >预约抢购商品</el-tag
          >
          <el-tag v-else type="warning">优先抢购商品</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="商品编号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.no }}
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="商品封面" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            class="image-url-150"
            :src="scope.row.cover"
            lazy
            :preview-src-list="[scope.row.cover]"
          ></el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品资源" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            class="image-url-150"
            :src="scope.row.resources_url"
            lazy
            :preview-src-list="[scope.row.resources_url]"
          ></el-image>
        </template>
      </el-table-column> -->
      <el-table-column label="创作者姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.creator_name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="创作者头像" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            class="image-url-150"
            :src="scope.row.creator_avatar"
            lazy
            :preview-src-list="[scope.row.creator_avatar]"
          ></el-image>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="简介" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.synopsis }}
        </template>
      </el-table-column> -->
      <el-table-column label="发行方" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.issuer.nickname }}
        </template>
      </el-table-column>
      <el-table-column label="价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column label="发行数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_num }}
        </template>
      </el-table-column>
      <el-table-column label="已发行数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.issued_num }}
        </template>
      </el-table-column>
      <el-table-column label="空投锁定数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.back_lock_num }}
        </template>
      </el-table-column>
      <el-table-column label="发行状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.handle_status == 0" type="primary"
            >未发行</el-tag
          >
          <el-tag v-else-if="scope.row.handle_status == 1" type="warning"
            >发行中</el-tag
          >
          <el-tag v-else-if="scope.row.handle_status == 2" type="success"
            >发行成功</el-tag
          >
          <el-tag v-else type="danger">发行失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="剩余数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.surplus_num }}
        </template>
      </el-table-column>
      <el-table-column label="已售" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_num - scope.row.surplus_num || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="是否显示库存" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_show_surplus_num == 1" type="success"
            >是</el-tag
          >
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="开售时间/预约时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.opening_at }}
        </template>
      </el-table-column>
      <el-table-column label="是否允许转赠" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_pass_on == 1" type="success">是</el-tag>
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否往期回顾" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_review_show == 1" type="success"
            >是</el-tag
          >
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否允许寄售" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_consignment == 1" type="success"
            >是</el-tag
          >
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="寄售最低价格" min-width="110" align="center">
        <template slot-scope="scope">
          <el-input
            ref="gain"
            size="mini"
            v-if="scope.row.isPriceEdit"
            @blur="priceBlurClick(scope)"
            :autofocus="true"
            v-model="scope.row.consignment_lowest_price"
            oninput="value = value.match(/\d+\.?\d{0,2}/)"
          ></el-input>
          <span v-else>
            {{ scope.row.consignment_lowest_price }}<i class="el-icon-edit"></i
          ></span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="砍价人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.bargain_num }}
        </template>
      </el-table-column> -->

      <el-table-column
        label="操作"
        width="280"
        align="center"
        class-name="fixed-height"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleCreate(scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            >下架</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            >上架</el-button
          >
          <el-button
            size="mini"
            type="success"
            v-if="scope.row.handle_status == 0"
            @click="issue(scope.row.id)"
          >
            发行
          </el-button>
          <el-button
            size="mini"
            type="success"
            v-else-if="scope.row.handle_status == 2 && scope.row.type == 2"
            @click="randomWin(scope.row.id)"
          >
            预售申请列表
          </el-button>
          <el-button
            size="mini"
            type="warning"
            @click="show(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            锁定
          </el-button>
          <el-button
            size="mini"
            type="success"
            @click="show1(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            解锁
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="showSetting(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2 && scope.row.category == 2"
          >
            盲盒设置
          </el-button>
          <!-- <el-button
            size="mini"
            type="primary"
            @click="showMergeInfoSetting(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            合成信息设置
          </el-button> -->
          <el-button
            size="mini"
            type="primary"
            @click="showMergeSetting(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            合成设置
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="showInvitationConfig(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            拉新设置
          </el-button>
          <el-button
            size="mini"
            type="success"
            @click="nftList(scope.row.id)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            NFT管理
          </el-button>

          <el-button
            size="mini"
            type="info"
            @click="preview(scope.row.id)"
            style="margin-top: 5px"
          >
            预览
          </el-button>
          <el-button
            v-if="scope.row.is_pass_on == 1"
            size="mini"
            type="danger"
            style="margin-top: 5px"
            @click="changeIsPassOn(scope.row.id, '禁止转赠')"
            >禁止转赠</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            style="margin-top: 5px"
            @click="changeIsPassOn(scope.row.id, '允许转赠')"
            >允许转赠</el-button
          >
          <el-button
            v-if="
              scope.row.is_review_show == 1 && !scope.row.is_setting_merge_info
            "
            size="mini"
            type="danger"
            style="margin-top: 5px"
            @click="changeIsReviewShow(scope.row.id, '取消往期回顾')"
            >取消往期回顾</el-button
          >
          <el-button
            v-if="
              scope.row.is_review_show == 0 && !scope.row.is_setting_merge_info
            "
            size="mini"
            type="success"
            style="margin-top: 5px"
            @click="changeIsReviewShow(scope.row.id, '加入往期回顾')"
            >加入往期回顾</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="showEnergyMergeSetting(scope.row)"
            style="margin-top: 5px"
            v-if="scope.row.handle_status == 2"
          >
            猩能源合成
          </el-button>
          <el-button
            v-if="scope.row.is_consignment == 1"
            size="mini"
            type="danger"
            @click="changeIsConsignment(scope.row.id, '禁止寄售')"
            >禁止寄售</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="changeIsConsignment(scope.row.id, '允许寄售')"
            >允许寄售</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row.id)"
            style="margin-top: 5px"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="锁定"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-form-item label="总后台锁定的数量：">
          {{ back_lock_num }}
        </el-form-item>
        <el-form-item label="锁定数量" prop="num">
          <el-input-number
            v-model="form.num"
            :min="1"
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="解锁"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-form-item label="总后台锁定的数量：">
          {{ back_lock_num }}
        </el-form-item>
        <el-form-item label="解锁数量" prop="num">
          <el-input-number
            v-model="form.num"
            :min="1"
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="盲盒设置"
      :visible.sync="blindBoxShow"
      :close-on-click-modal="false"
    >
      <el-button
        type="primary"
        @click="addClub"
        v-if="!disable"
        style="margin-left: 35px"
        >添加</el-button
      >
      <el-form ref="form" label-width="120px">
        <div v-for="(v, i) in blindBoxSettingShow" :key="i">
          <el-form-item label="锁定的NFT">
            <el-select
              v-model="blindBoxSettingShow[i].product_id"
              placeholder="请选择产品"
              clearable
              style="width: 300px"
              class="filter-item"
              :disabled="disable"
              filterable
            >
              <el-option
                v-for="(item, key) in products"
                :key="key"
                :label="item.name"
                :value="item.id"
                :disabled="
                  blindBoxSettingShow.findIndex(
                    (e) => e.product_id === item.id
                  ) >= 0
                    ? true
                    : false
                "
              />
            </el-select>
            数量
            <el-input
              type="number"
              v-model="blindBoxSettingShow[i].num"
              :min="0"
              style="width: 20%"
              oninput="value = value.replace(/[^\d]/g, '')"
              :disabled="disable"
            ></el-input>
            <el-button
              v-if="!disable"
              type="danger"
              @click="delClub(i)"
              style="margin-left: 5px"
              >删除</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!disable">
        <el-button @click="blindBoxShow = false">取消</el-button>
        <el-button type="primary" @click="blindBoxStore" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="合成信息设置"
      :visible.sync="mergeInfoShow"
      :close-on-click-modal="false"
    >
      <el-form
        ref="mergeInfoSetting"
        :rules="mergeInfoRules"
        :model="mergeInfoSetting"
        label-width="140px"
      >
        <el-form-item label="合成开始时间" prop="start_at">
          <el-date-picker
            v-model="mergeInfoSetting.start_at"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合成结束时间" prop="end_at">
          <el-date-picker
            v-model="mergeInfoSetting.end_at"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合成说明" prop="explain">
          <el-input
            v-model="mergeInfoSetting.explain"
            placeholder="请输入合成说明"
            type="textarea"
            :rows="4"
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mergeInfoShow = false">取消</el-button>
        <el-button type="primary" @click="mergeInfoStore" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="合成设置"
      :visible.sync="mergeShow"
      :close-on-click-modal="false"
      width="50%"
    >
      <div>
        <h3>信息设置</h3>
        <el-form
          ref="mergeInfoSetting"
          :rules="mergeInfoRules"
          :model="mergeInfoSetting"
          label-width="140px"
          size="mini"
        >
          <el-form-item label="合成开始时间">
            <el-date-picker
              v-model="merge_start_date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-time-picker
              arrow-control
              v-model="merge_start_time"
              placeholder="任意时间点"
              style="margin-left: 5px"
              value-format="HH:mm:ss"
            >
            </el-time-picker>
            <!-- <el-date-picker
              v-model="mergeInfoSetting.start_at"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker> -->
          </el-form-item>
          <el-form-item label="合成结束时间">
            <el-date-picker
              v-model="merge_end_date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-time-picker
              arrow-control
              v-model="merge_end_time"
              placeholder="任意时间点"
              style="margin-left: 5px"
              value-format="HH:mm:ss"
            >
            </el-time-picker>
            <!-- <el-date-picker
              v-model="mergeInfoSetting.end_at"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker> -->
          </el-form-item>
          <el-form-item label="合成说明" prop="explain">
            <el-input
              v-model="mergeInfoSetting.explain"
              placeholder="请输入合成说明"
              type="textarea"
              :rows="4"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="mergeInfoShow = false">取消</el-button> -->
          <el-button
            type="primary"
            @click="mergeInfoStore"
            :loading="btnLoading1"
            size="mini"
            >保存</el-button
          >
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <h3>碎片设置</h3>
        <el-form ref="form" label-width="120px" size="mini">
          <el-button type="primary" @click="addModuleClub(i)" size="mini"
            >添加碎片</el-button
          >
          <div
            v-for="(v, i) in mergeSetting.merge_modules"
            :key="i"
            style="border: 1px solid #dfe6ec; margin-top: 10px"
          >
            <el-form-item label="碎片名称" style="margin-top: 10px">
              <el-input
                type="text"
                v-model="v.name"
                style="width: 50%"
              ></el-input>
            </el-form-item>
            <el-form-item label="碎片数量">
              <el-input
                type="number"
                v-model="v.num"
                :min="0"
                style="width: 50%"
                oninput="value = value.replace(/[^\d]/g, '')"
              ></el-input>
            </el-form-item>
            <el-button
              type="primary"
              @click="addMergeClub(i)"
              style="margin-left: 26px"
              size="mini"
              >添加产品</el-button
            >
            <el-form-item label="碎片产品" style="margin-top: 5px">
              <div v-for="(merge, merge_i) in v.merges" :key="merge_i">
                <el-select
                  v-model="merge.child_product_id"
                  placeholder="请选择产品"
                  clearable
                  style="width: 200px; margin-top: 5px"
                  class="filter-item"
                  filterable
                >
                  <el-option
                    v-for="(item, key) in products"
                    :key="key"
                    :label="item.no + '(' + item.name + ')'"
                    :value="item.id"
                    :disabled="
                      v.merges.findIndex(
                        (e) => e.child_product_id === item.id
                      ) >= 0
                        ? true
                        : false
                    "
                  />
                </el-select>
                <el-select
                  v-model="merge.burn_type"
                  placeholder="销毁类型"
                  clearable
                  style="width: 150px; margin-left: 5px"
                  class="filter-item"
                >
                  <el-option label="完全销毁" :value="1" />
                  <el-option label="仅链上销毁" :value="2" />
                  <el-option label="不销毁" :value="3" />
                </el-select>
                <el-input
                  v-if="merge.burn_type == 3"
                  type="number"
                  placeholder="使用次数"
                  v-model="merge.num"
                  :min="0"
                  style="width: 20%; margin-left: 5px"
                  oninput="value = value.replace(/[^\d]/g, '')"
                ></el-input>
                <el-button
                  type="danger"
                  @click="delMergeClub(i, merge_i)"
                  style="margin-left: 5px"
                  size="mini"
                  >删除产品</el-button
                >
              </div>
            </el-form-item>
            <el-button
              type="danger"
              @click="delModuleClub(i)"
              style="margin-left: 90%; margin-bottom: 5px"
              size="mini"
              >删除碎片</el-button
            >
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="mergeShow = false" size="mini">取消</el-button> -->
          <el-button
            type="primary"
            @click="mergeStore"
            :loading="btnLoading"
            size="mini"
            style="margin-top: 5px"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="猩能源合成"
      :visible.sync="energyMergeShow"
      :close-on-click-modal="false"
      width="50%"
    >
      <div>
        <!-- <h3>信息设置</h3> -->
        <el-form
          ref="energyMergeInfoSetting"
          :rules="energyMergeInfoRules"
          :model="energyMergeInfoSetting"
          label-width="140px"
          size="mini"
        >
          <el-form-item label="猩能源">
            <el-input
              type="number"
              v-model="energyMergeInfoSetting.energy"
              :min="0"
              style="width: 50%"
              oninput="value = value.replace(/[^\d]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item label="合成开始时间">
            <el-date-picker
              v-model="energy_merge_start_date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-time-picker
              arrow-control
              v-model="energy_merge_start_time"
              placeholder="任意时间点"
              style="margin-left: 5px"
              value-format="HH:mm:ss"
            >
            </el-time-picker>
            <!-- <el-date-picker
              v-model="mergeInfoSetting.start_at"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker> -->
          </el-form-item>
          <el-form-item label="合成结束时间">
            <el-date-picker
              v-model="energy_merge_end_date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-time-picker
              arrow-control
              v-model="energy_merge_end_time"
              placeholder="任意时间点"
              style="margin-left: 5px"
              value-format="HH:mm:ss"
            >
            </el-time-picker>
            <!-- <el-date-picker
              v-model="mergeInfoSetting.end_at"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker> -->
          </el-form-item>
          <el-form-item label="合成说明" prop="explain">
            <el-input
              v-model="energyMergeInfoSetting.explain"
              placeholder="请输入合成说明"
              type="textarea"
              :rows="4"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <div
            v-for="(v, i) in energyMergeInfoSetting.merge_modules"
            :key="i"
            style="border: 1px solid #dfe6ec; margin-top: 10px"
          >
            <span v-if="v.is_required == 1">
              <el-form-item label="必选藏品(非必填)" style="margin-top: 5px">
                <div v-for="(merge, merge_i) in v.merges" :key="merge_i">
                  <el-select
                    v-model="merge.child_product_id"
                    placeholder="请选择藏品"
                    clearable
                    style="width: 200px; margin-top: 5px"
                    class="filter-item"
                    filterable
                  >
                    <el-option
                      v-for="(item, key) in products"
                      :key="key"
                      :label="item.no + '(' + item.name + ')'"
                      :value="item.id"
                      :disabled="
                        v.merges.findIndex(
                          (e) => e.child_product_id === item.id
                        ) >= 0
                          ? true
                          : false
                      "
                    />
                  </el-select>
                </div>
              </el-form-item>
            </span>
            <span v-else>
              <!-- <el-form-item label="碎片名称" style="margin-top: 10px">
              <el-input
                type="text"
                v-model="v.name"
                style="width: 50%"
              ></el-input>
            </el-form-item>
            <el-form-item label="碎片数量">
              <el-input
                type="number"
                v-model="v.num"
                :min="0"
                style="width: 50%"
                oninput="value = value.replace(/[^\d]/g, '')"
              ></el-input>
            </el-form-item> -->
              <el-button
                type="primary"
                @click="addEnergyMergeClub(i)"
                style="margin-left: 26px; margin-top: 10px"
                size="mini"
                >添加藏品</el-button
              >
              <el-form-item label="碎片藏品" style="margin-top: 5px">
                <div v-for="(merge, merge_i) in v.merges" :key="merge_i">
                  <el-select
                    v-model="merge.child_product_id"
                    placeholder="请选择藏品"
                    clearable
                    style="width: 200px; margin-top: 5px"
                    class="filter-item"
                    filterable
                  >
                    <el-option
                      v-for="(item, key) in products"
                      :key="key"
                      :label="item.no + '(' + item.name + ')'"
                      :value="item.id"
                      :disabled="
                        v.merges.findIndex(
                          (e) => e.child_product_id === item.id
                        ) >= 0
                          ? true
                          : false
                      "
                    />
                  </el-select>
                  <!-- <el-select
                  v-model="merge.burn_type"
                  placeholder="销毁类型"
                  clearable
                  style="width: 150px; margin-left: 5px"
                  class="filter-item"
                >
                  <el-option label="完全销毁" :value="1" />
                  <el-option label="仅链上销毁" :value="2" />
                  <el-option label="不销毁" :value="3" />
                </el-select>
                <el-input
                  v-if="merge.burn_type == 3"
                  type="number"
                  placeholder="使用次数"
                  v-model="merge.num"
                  :min="0"
                  style="width: 20%; margin-left: 5px"
                  oninput="value = value.replace(/[^\d]/g, '')"
                ></el-input> -->
                  <el-button
                    type="danger"
                    @click="delEnergyMergeClub(i, merge_i)"
                    style="margin-left: 5px"
                    size="mini"
                    >删除藏品</el-button
                  >
                </div>
              </el-form-item>
            </span>

            <!-- <el-button
              type="danger"
              @click="delModuleClub(i)"
              style="margin-left: 90%; margin-bottom: 5px"
              size="mini"
              >删除碎片</el-button
            > -->
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button @click="energyMergeShow = false" size="mini"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="energeMergeInfoStore"
            :loading="btnLoading1"
            size="mini"
            >保存</el-button
          >
        </div>
      </div>
      <!-- <el-divider></el-divider>
      <div>
        <h3>碎片设置</h3>
        <el-form ref="form" label-width="120px" size="mini">
          <el-button type="primary" @click="addModuleClub(i)" size="mini"
            >添加碎片</el-button
          >
          <div
            v-for="(v, i) in energyMergeInfoSetting.merge_modules"
            :key="i"
            style="border: 1px solid #dfe6ec; margin-top: 10px"
          >
            <el-form-item label="碎片名称" style="margin-top: 10px">
              <el-input
                type="text"
                v-model="v.name"
                style="width: 50%"
              ></el-input>
            </el-form-item>
            <el-form-item label="碎片数量">
              <el-input
                type="number"
                v-model="v.num"
                :min="0"
                style="width: 50%"
                oninput="value = value.replace(/[^\d]/g, '')"
              ></el-input>
            </el-form-item>
            <el-button
              type="primary"
              @click="addMergeClub(i)"
              style="margin-left: 26px"
              size="mini"
              >添加产品</el-button
            >
            <el-form-item label="碎片产品" style="margin-top: 5px">
              <div v-for="(merge, merge_i) in v.merges" :key="merge_i">
                <el-select
                  v-model="merge.child_product_id"
                  placeholder="请选择产品"
                  clearable
                  style="width: 200px; margin-top: 5px"
                  class="filter-item"
                  filterable
                >
                  <el-option
                    v-for="(item, key) in products"
                    :key="key"
                    :label="item.no + '(' + item.name + ')'"
                    :value="item.id"
                    :disabled="
                      v.merges.findIndex(
                        (e) => e.child_product_id === item.id
                      ) >= 0
                        ? true
                        : false
                    "
                  />
                </el-select>
                <el-select
                  v-model="merge.burn_type"
                  placeholder="销毁类型"
                  clearable
                  style="width: 150px; margin-left: 5px"
                  class="filter-item"
                >
                  <el-option label="完全销毁" :value="1" />
                  <el-option label="仅链上销毁" :value="2" />
                  <el-option label="不销毁" :value="3" />
                </el-select>
                <el-input
                  v-if="merge.burn_type == 3"
                  type="number"
                  placeholder="使用次数"
                  v-model="merge.num"
                  :min="0"
                  style="width: 20%; margin-left: 5px"
                  oninput="value = value.replace(/[^\d]/g, '')"
                ></el-input>
                <el-button
                  type="danger"
                  @click="delMergeClub(i, merge_i)"
                  style="margin-left: 5px"
                  size="mini"
                  >删除产品</el-button
                >
              </div>
            </el-form-item>
            <el-button
              type="danger"
              @click="delModuleClub(i)"
              style="margin-left: 90%; margin-bottom: 5px"
              size="mini"
              >删除碎片</el-button
            >
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          
          <el-button
            type="primary"
            @click="mergeStore"
            :loading="btnLoading"
            size="mini"
            style="margin-top: 5px"
            >保存</el-button
          >
        </div> 
      </div>-->
    </el-dialog>

    <el-dialog
      title="拉新设置"
      :visible.sync="invitationConfigShow"
      :close-on-click-modal="false"
      width="50%"
    >
      <div>
        <el-form
          ref="invitationConfig"
          :rules="invitationConfigRules"
          :model="invitationConfig"
          label-width="200px"
          size="mini"
        >
          <el-form-item label="是否开启">
            <el-select
              v-model="invitationConfig.is_open"
              placeholder="是否开启"
              clearable
              style="width: 150px; margin-left: 5px"
              class="filter-item"
            >
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="最多购买数量" prop="max_buy_num_limit">
            <el-input
              type="number"
              v-model="invitationConfig.max_buy_num_limit"
              style="width: 200px"
              :max="9999999999"
              :min="0"
              oninput="value = value.replace(/[^\d]/g, '')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="每邀请一个增加购买数量"
            prop="invite_one_add_buy_num"
          >
            <el-input
              type="number"
              v-model="invitationConfig.invite_one_add_buy_num"
              style="width: 200px"
              :max="9999999999"
              :min="0"
              oninput="value = value.replace(/[^\d]/g, '')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="mergeInfoShow = false">取消</el-button> -->
          <el-button
            type="primary"
            @click="invitationConfigStore"
            :loading="btnLoading2"
            size="mini"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="导入数据预览"
      :visible.sync="importDataDialogVisible"
      center
      width="60%"
      :close-on-click-modal="false"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 500px">
          <el-table :data="yulanData" style="width: 1100px">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.index || "" }}
              </template>
            </el-table-column>
            <el-table-column label="电话" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.phone || "" }}
              </template>
            </el-table-column>
            <el-table-column label="产品编号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.product_no || "" }}
              </template>
            </el-table-column>
            <el-table-column label="空投数量" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.num || "" }}
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importDataDialogVisible = false">取消</el-button>
        <el-button @click="importSaveData" type="primary" :loading="btnLoading"
          >确认导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";
import { excel2Json } from "@/utils/excel";
export default {
  components: { downloadExcel },
  data() {
    return {
      yulanData: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        title: "",
        is_on: "",
        is_index_show: "",
        category: "",
      },
      btnLoading: false,
      btnLoading1: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      importDataDialogVisible: false,
      blindBoxShow: false,
      mergeShow: false,
      mergeInfoShow: false,
      energyMergeShow: false,
      dialogStatus: "",
      disable: false,
      back_lock_num: 0,
      merge_start_date: null,
      merge_start_time: null,
      merge_end_date: null,
      merge_end_time: null,
      energy_merge_start_date: null,
      energy_merge_start_time: null,
      energy_merge_end_date: null,
      energy_merge_end_time: null,
      form: {
        id: "",
        num: 1,
      },
      rules: {
        num: [
          { required: true, message: "锁定数量不能为空", trigger: "change" },
        ],
      },
      invitationConfigRules: {},
      mergeInfoRules: {
        start_at: [
          {
            required: true,
            message: "合成开始时间不能为空",
            trigger: "change",
          },
        ],
        end_at: [
          {
            required: true,
            message: "合成结束时间不能为空",
            trigger: "change",
          },
        ],
        explain: [
          { required: true, message: "合成说明不能为空", trigger: "change" },
        ],
      },
      energyMergeInfoRules: {
        start_at: [
          {
            required: true,
            message: "合成开始时间不能为空",
            trigger: "change",
          },
        ],
        end_at: [
          {
            required: true,
            message: "合成结束时间不能为空",
            trigger: "change",
          },
        ],
        explain: [
          { required: true, message: "合成说明不能为空", trigger: "change" },
        ],
        energy: {
          required: true,
          message: "猩能源不能为空",
          trigger: "change",
        },
      },
      blindBoxSetting: {
        product_id: "",
        blind_box: [
          {
            product_id: "",
            num: "",
          },
        ],
      },
      blindBoxSettingShow: [
        {
          product_id: "",
          num: "",
        },
      ],
      products: [],
      mergeInfoSetting: {
        product_id: "",
        start_at: "",
        end_at: "",
        explain: "",
      },
      mergeSetting: {
        product_id: "",
        merge_modules: [
          {
            name: "",
            num: "",
            merges: [
              {
                child_product_id: "",
                burn_type: "",
              },
            ],
          },
        ],
      },
      energyMergeInfoSetting: {
        product_id: "",
        start_at: "",
        end_at: "",
        explain: "",
        energy: "",
        merge_modules: [
          {
            name: "第一种碎片",
            num: 0,
            merges: [
              {
                child_product_id: "",
                burn_type: "",
              },
            ],
          },
        ],
      },
      invitationConfigShow: false,
      invitationConfig: {
        product_id: "",
        is_open: 0,
        max_buy_num_limit: "",
        invite_one_add_buy_num: "",
      },
      art_museums: [],
      product_categories: [],
    };
  },
  created() {
    this.getProductCategory();
    this.getArtMuseum();
    this.getList();
  },
  methods: {
    getProductCategory() {
      request({
        url: "/api/backend/product/categoryList",
        method: "get",
        params: { limit: 999999999999 },
      }).then((response) => {
        this.product_categories = response.data.data;
      });
    },
    getArtMuseum() {
      request({
        url: "/api/backend/artMuseum/list",
        method: "get",
        params: { limit: 999999999999 },
      }).then((response) => {
        this.art_museums = response.data.data;
      });
    },
    handleImportOrders(file) {
      console.log(1111);
      this.yulanData = [];
      file = file.raw;
      if (
        !(file.name.split(".")[1] == "xlsx" || file.name.split(".")[1] == "xls")
      ) {
        this.$message.error("上传文件格式不正确，请检查选择的文件");
        return;
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData);
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error("数据不能为空");
          return;
        }
        excelData.forEach((element, index) => {
          console.log(element, "--------", index);
          this.yulanData.push({
            index: element["序号"],
            phone: element["电话"],
            product_no: element["产品编号"] || "",
            num: element["空投数量"] || "",
          });
        });
        this.importDataDialogVisible = true;
        console.log(this.yulanData, "=============");
      });
    },
    importSaveData() {
      for (let index = 0; index < this.yulanData.length; index++) {
        const item = this.yulanData[index];
        for (var key in item) {
          if (!item[key]) {
            this.$message({
              type: "error",
              message: "请完善数据!!",
            });
            return;
          }
        }
      }
      request({
        url: "/api/backend/product/airdrop",
        method: "post",
        data: {
          airdrops: this.yulanData,
        },
      })
        .then((response) => {
          this.btnLoading = false;
          this.importDataDialogVisible = false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch((err) => {
          this.btnLoading = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    cellClick(row, column, event) {
      if (column.label === "寄售最低价格") {
        this.$set(row, "isPriceEdit", true);
      }
      this.$forceUpdate();
    },
    priceBlurClick({ row, column }) {
      this.$set(row, "isPriceEdit", false);
      request({
        url: "/api/backend/product/updatePrice",
        method: "post",
        data: {
          id: row.id,
          consignment_lowest_price: row.consignment_lowest_price,
        },
      }).then(() => {
        this.getList();
        this.$forceUpdate(); //强制更新
      });
    },
    participation(row, type) {
      // let data= JSON.stringify(row)
      if (type == 1) {
        this.$router.push(`/product/participation_pt?data=${row.id}`);
      } else {
        this.$router.push(`/product/participation_kj?data=${row.id}`);
      }
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getProductList(id, type = 1) {
      let not_category = null;
      if (type == 2) {
        not_category = 2;
      }
      request({
        url: "/api/backend/product/list",
        method: "get",
        params: {
          limit: 99999999999999999999,
          not_id: id,
          not_category: not_category,
        },
      }).then((response) => {
        this.products = response.data.data;
      });
    },
    randomWin(id) {
      this.$router.push(`/product/reservedApplyList?id=${id}`);
    },
    nftList(id) {
      this.$router.push(`/product/nftList?id=${id}`);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate(row) {
      this.$router.push(`/product/list_edit?id=${row.id}`);
    },
    show(row) {
      this.dialogStatus = "锁定";
      this.dialogFormVisible = true;
      this.form.id = row.id;
      this.back_lock_num = row.back_lock_num;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    show1(row) {
      this.dialogStatus = "解锁";
      this.dialogFormVisible1 = true;
      this.form.id = row.id;
      this.back_lock_num = row.back_lock_num;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    showSetting(row) {
      this.dialogStatus = "盲盒设置";
      this.blindBoxShow = true;
      this.blindBoxSetting.product_id = row.id;
      this.getProductList(row.id, 2);
      request({
        url: "/api/backend/blindBox/detail",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        if (response.data.length) {
          this.blindBoxSettingShow = [];
          response.data.forEach((e) => {
            this.blindBoxSettingShow.push({
              product_id: e.user_product_belong_product_id,
              num: e.surplus_num,
            });
          });
          this.disable = true;
        } else {
          this.blindBoxSettingShow = [
            {
              product_id: "",
              num: "",
            },
          ];
          this.disable = false;
        }
      });
    },
    showMergeSetting(row) {
      this.dialogStatus = "合成设置";

      this.mergeSetting.product_id = row.id;
      this.getProductList(row.id);
      request({
        url: "/api/backend/product/mergeSettingDetail",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        if (response.data.length) {
          this.mergeSetting.merge_modules = response.data;
        } else {
          this.mergeSetting.merge_modules = [
            {
              name: "",
              num: "",
              merges: [
                {
                  child_product_id: "",
                  child_product_num: "",
                },
              ],
            },
          ];
        }
      });
      request({
        url: "/api/backend/product/mergeInfo",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        this.merge_start_date = null;
        this.merge_start_time = null;
        this.merge_end_date = null;
        this.merge_end_time = null;
        if (response.data) {
          this.mergeInfoSetting = response.data;
          let start = this.mergeInfoSetting.start_at.split(" ");
          let end = this.mergeInfoSetting.end_at.split(" ");
          this.merge_start_date = start[0];
          this.merge_start_time = start[1];
          this.merge_end_date = end[0];
          this.merge_end_time = end[1];
        } else {
          this.mergeInfoSetting = {
            product_id: row.id,
            start_at: "",
            end_at: "",
            explain: "",
          };
        }
      });
      this.mergeShow = true;
    },
    showMergeInfoSetting(row) {
      this.dialogStatus = "合成信息设置";
      request({
        url: "/api/backend/product/mergeInfo",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        if (response.data) {
          this.mergeInfoSetting = response.data;
        } else {
          this.mergeInfoSetting = {
            product_id: row.id,
            start_at: "",
            end_at: "",
            explain: "",
          };
        }
      });
      this.mergeInfoShow = true;
    },
    showEnergyMergeSetting(row) {
      this.dialogStatus = "猩能源合成";

      this.mergeSetting.product_id = row.id;
      this.getProductList(row.id);

      request({
        url: "/api/backend/product/energyMergeInfo",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        this.energy_merge_start_date = null;
        this.energy_merge_start_time = null;
        this.energy_merge_end_date = null;
        this.energy_merge_end_time = null;
        if (response.data) {
          this.energyMergeInfoSetting = response.data;
          let start = this.energyMergeInfoSetting.start_at.split(" ");
          let end = this.energyMergeInfoSetting.end_at.split(" ");
          this.energy_merge_start_date = start[0];
          this.energy_merge_start_time = start[1];
          this.energy_merge_end_date = end[0];
          this.energy_merge_end_time = end[1];
          console.log(this.energy_merge_end_time);
          if (this.energyMergeInfoSetting.merge_modules[0].is_required == 0) {
            this.energyMergeInfoSetting.merge_modules.unshift({
              name: "必选碎片",
              num: 0,
              is_required: 1,
              merges: [
                {
                  child_product_id: "",
                  child_product_num: "",
                  burn_type: 1,
                },
              ],
            });
          }
        } else {
          this.energyMergeInfoSetting = {
            product_id: row.id,
            start_at: "",
            end_at: "",
            explain: "",
            energy: "",
            merge_modules: [
              {
                name: "必选碎片",
                num: 0,
                is_required: 1,
                merges: [
                  {
                    child_product_id: "",
                    child_product_num: "",
                    burn_type: 1,
                  },
                ],
              },
              {
                name: "第一种碎片",
                num: 0,
                is_required: 0,
                merges: [
                  {
                    child_product_id: "",
                    child_product_num: "",
                    burn_type: 1,
                  },
                ],
              },
            ],
          };
        }
      });
      // request({
      //   url: "/api/backend/product/energyMergeSettingDetail",
      //   method: "get",
      //   params: {
      //     product_id: row.id,
      //   },
      // }).then((response) => {
      //   if (response.data.length) {
      //     this.energyMergeInfoSetting.merge_modules = response.data;
      //   } else {
      //     this.energyMergeInfoSetting.merge_modules = [
      //       {
      //         name: "第一种碎片",
      //         num: 0,
      //         merges: [
      //           {
      //             child_product_id: "",
      //             child_product_num: "",
      //             burn_type: 1,
      //           },
      //         ],
      //       },
      //     ];
      //   }
      // });
      this.energyMergeShow = true;
    },
    isHave(id) {
      console.log(
        this.mergeSetting.merges.findIndex(
          (item) => item.child_product_id === id
        )
      );
    },
    saveData() {
      if (!this.form.link_type) {
        this.form.link = "";
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/lock",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    saveData1() {
      if (!this.form.num > this.back_lock_num) {
        this.$message.error("解锁的数量不能大于剩余数量");
        return;
        1;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/unLock",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible1 = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    blindBoxStore() {
      var b = true;
      this.blindBoxSetting.blind_box = [];
      this.blindBoxSettingShow.forEach((e) => {
        if (!e.product_id) {
          this.$message.error("产品不能为空");
          b = false;
          return;
        }
        // if (e.num) {
        //   this.$message.error("数量不能为空");
        //   return;
        // }
        this.blindBoxSetting.blind_box.push(e);
      });
      if (!b) {
        return;
      }
      // this.$refs["form"].validate((valid) => {
      //   if (valid) {
      this.btnLoading = true;
      request({
        url: "/api/backend/blindBox/store",
        method: "post",
        data: this.blindBoxSetting,
        timeout: 5 * 60 * 1000,
      })
        .then((response) => {
          this.btnLoading = false;
          this.blindBoxShow = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getList();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
      //   }
      // });
    },
    mergeInfoStore() {
      if (!this.merge_start_date) {
        this.$message.error("合成开始日期不能为空！");
        return;
      }
      if (!this.merge_start_time) {
        this.$message.error("合成开始时间不能为空！");
        return;
      }
      if (!this.merge_end_date) {
        this.$message.error("合成结束日期不能为空！");
        return;
      }
      if (!this.merge_end_time) {
        this.$message.error("合成结束时间不能为空！");
        return;
      }
      this.mergeInfoSetting.start_at =
        this.merge_start_date + " " + this.merge_start_time;
      this.mergeInfoSetting.end_at =
        this.merge_end_date + " " + this.merge_end_time;
      if (
        this.$moment(this.mergeInfoSetting.start_at).valueOf() >
        this.$moment(this.mergeInfoSetting.end_at).valueOf()
      ) {
        this.$message.error("合成开始时间不能大于合成结束时间！");
        return;
      }
      this.$refs["mergeInfoSetting"].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true;
          request({
            url: "/api/backend/product/mergeInfoStore",
            method: "post",
            data: this.mergeInfoSetting,
          })
            .then((response) => {
              this.btnLoading1 = false;
              // this.mergeInfoShow = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              // this.getList();
            })
            .catch((err) => {
              this.btnLoading1 = false;
            })
            .finally(() => {
              this.btnLoading1 = false;
            });
        }
      });
    },
    energeMergeInfoStore() {
      if (!this.energy_merge_start_date) {
        this.$message.error("合成开始日期不能为空！");
        return;
      }
      if (!this.energy_merge_start_time) {
        this.$message.error("合成开始时间不能为空！");
        return;
      }
      if (!this.energy_merge_end_date) {
        this.$message.error("合成结束日期不能为空！");
        return;
      }
      if (!this.energy_merge_end_time) {
        this.$message.error("合成结束时间不能为空！");
        return;
      }
      this.energyMergeInfoSetting.start_at =
        this.energy_merge_start_date + " " + this.energy_merge_start_time;
      this.energyMergeInfoSetting.end_at =
        this.energy_merge_end_date + " " + this.energy_merge_end_time;
      if (
        this.$moment(this.energyMergeInfoSetting.start_at).valueOf() >
        this.$moment(this.energyMergeInfoSetting.end_at).valueOf()
      ) {
        this.$message.error("合成开始时间不能大于合成结束时间！");
        return;
      }
      var data = JSON.parse(JSON.stringify(this.energyMergeInfoSetting));
      var merge_modules = [];
      var b = true;
      data.merge_modules.forEach((v) => {
        v.merges.forEach((v1) => {
          if (v.is_required == 0 && !v1.child_product_id) {
            this.$message.error("藏品不能为空");
            b = false;
            return;
          }
        });
        if (v.is_required == 1 && !v.merges[0].child_product_id) {
        } else {
          merge_modules.push(v);
        }
      });
      data.merge_modules = merge_modules;
      if (!b) {
        return;
      }

      this.$refs["energyMergeInfoSetting"].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true;
          request({
            url: "/api/backend/product/energyMergeInfoStore",
            method: "post",
            data: data,
          })
            .then((response) => {
              this.btnLoading1 = false;
              // this.mergeInfoShow = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              // this.getList();
            })
            .catch((err) => {
              this.btnLoading1 = false;
            })
            .finally(() => {
              this.btnLoading1 = false;
            });
        }
      });
    },
    mergeStore() {
      var b = true;

      this.mergeSetting.merge_modules.forEach((e) => {
        if (!e.name) {
          this.$message.error("碎片名称不能为空");
          b = false;
          return;
        }
        if (!e.num) {
          this.$message.error("碎片数量不能为空");
          b = false;
          return;
        }
        e.merges.forEach((e) => {
          if (!e.child_product_id) {
            this.$message.error("产品不能为空");
            b = false;
            return;
          }
        });
        if (!b) {
          return;
        }
      });

      if (!b) {
        return;
      }
      // this.$refs["form"].validate((valid) => {
      //   if (valid) {
      this.btnLoading = true;
      request({
        url: "/api/backend/product/mergeSettingStore",
        method: "post",
        data: this.mergeSetting,
      })
        .then((response) => {
          this.btnLoading = false;
          // this.mergeShow = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          // this.getList();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
      //   }
      // });
    },
    changeIsConsignment(val, text) {
      this.$confirm("此操作将" + text + "该nft, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/changeIsConsignment",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该nft, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/upDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //改变转赠状态
    changeIsPassOn(val, text) {
      this.$confirm("此操作将" + text + "该nft, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/changeIsPassOn",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //改变
    changeIsReviewShow(val, text) {
      this.$confirm("此操作将该nft" + text + ", 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/changeIsReviewShow",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },

    //上下架
    del(val) {
      this.$confirm("此操作将删除该nft, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/del",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    preview(id) {
      window.open(process.env.VUE_APP_PREVIEW_URL + id);
    },
    //删除
    handleShow(val, text) {
      this.$confirm("此操作将课程类型" + text + ", 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/course/categoryIndexShow",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //发行
    issue(val) {
      this.$confirm("此操作将发行该产品, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/issue",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    addClub() {
      this.blindBoxSettingShow.push({
        product_id: "",
        num: "",
      });
    },
    delClub(idx) {
      this.blindBoxSettingShow.splice(idx, 1);
    },
    addMergeClub(i) {
      this.mergeSetting.merge_modules[i].merges.push({
        child_product_id: "",
      });
    },
    delMergeClub(i, idx) {
      this.mergeSetting.merge_modules[i].merges.splice(idx, 1);
    },
    addEnergyMergeClub(i) {
      this.energyMergeInfoSetting.merge_modules[i].merges.push({
        child_product_id: "",
        burn_type: 1,
      });
    },
    delEnergyMergeClub(i, idx) {
      this.energyMergeInfoSetting.merge_modules[i].merges.splice(idx, 1);
    },
    addModuleClub() {
      this.mergeSetting.merge_modules.push({
        name: "",
        num: "",
        merges: [
          {
            child_product_id: "",
          },
        ],
      });
      console.log(this.mergeSetting.merge_modules);
    },
    delModuleClub(idx) {
      this.mergeSetting.merge_modules.splice(idx, 1);
    },
    showInvitationConfig(row) {
      this.dialogStatus = "拉新设置";

      this.invitationConfig.product_id = row.id;

      request({
        url: "/api/backend/product/invitationConfigDetail",
        method: "get",
        params: {
          product_id: row.id,
        },
      }).then((response) => {
        if (response.data) {
          this.invitationConfig = response.data;
        } else {
          this.invitationConfig = {
            product_id: row.id,
            is_open: 0,
            max_buy_num_limit: "",
            invite_one_add_buy_num: "",
          };
        }
      });
      this.invitationConfigShow = true;
    },
    invitationConfigStore() {
      if (
        this.invitationConfig.is_open == 1 &&
        (!this.invitationConfig.max_buy_num_limit ||
          !this.invitationConfig.invite_one_add_buy_num)
      ) {
        this.$message.error("请完善配置信息");
        return;
      }

      this.$refs["invitationConfig"].validate((valid) => {
        if (valid) {
          this.btnLoading2 = true;
          request({
            url: "/api/backend/product/invitationConfigStore",
            method: "post",
            data: this.invitationConfig,
          })
            .then((response) => {
              this.btnLoading2 = false;
              // this.mergeInfoShow = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              // this.getList();
            })
            .catch((err) => {
              this.btnLoading2 = false;
            })
            .finally(() => {
              this.btnLoading2 = false;
            });
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
